import React from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';

const MapWrapper = ({ children, isAddMarker, ...rest }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  });
  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>;
  }
  return <>{isLoaded && <GoogleMap {...rest}>
  <Marker visible={isAddMarker} position={{ lat: rest.center.lat, lng: rest.center.lng }} />{children}</GoogleMap>}</>;
};

export default MapWrapper;
